import { useInView } from './hooks/useInView';

const FEATURES = [
  {
    num: '01',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    ),
    title: 'Secure Wallet',
    desc: 'Multi-chain, self-custodial wallet architecture. Your keys. Your assets. Your sovereignty.',
    detail: 'Ethereum · BNB Chain · Polygon · Solana · and more',
    tags: ['Self-Custodial', 'Multi-Chain', 'Self-Sovereign'],
  },
  {
    num: '02',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <polyline points="16 3 21 3 21 8" />
        <line x1="4" y1="20" x2="21" y2="3" />
        <polyline points="21 16 21 21 16 21" />
        <line x1="15" y1="15" x2="21" y2="21" />
      </svg>
    ),
    title: 'Cross-Chain Interaction',
    desc: 'Seamlessly interact across ecosystems without friction. One interface, every network.',
    detail: 'Bridge assets, swap tokens, and interact with any chain without leaving the app.',
    tags: ['Interoperability', 'Frictionless'],
  },
  {
    num: '03',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    title: 'Military-Grade Security',
    desc: 'Advanced security layers protecting your assets at every level of the stack.',
    detail: 'PIN protection · Biometric auth · Encrypted key management · Secure recovery',
    tags: ['Biometric', 'Encrypted', 'PIN + 2FA'],
  },
  {
    num: '04',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="8" r="4" />
        <path d="M20 21a8 8 0 1 0-16 0" />
      </svg>
    ),
    title: 'Nomo-ID Protocol',
    desc: 'An open identity protocol that makes your verified identity reusable across the entire ecosystem — without repeated KYC loops.',
    detail: 'Complete verification once. Reuse across all connected services. Compatible with ZenPass and other decentralized ID providers.',
    tags: ['Nomo-ID', 'Reusable KYC', 'Portable'],
  },
  {
    num: '05',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
    title: 'WebOn Ecosystem',
    desc: 'NOMO is fully compatible with WebOn technology — bringing 70+ independent decentralized apps natively into your wallet experience.',
    detail: '70+ active WebOns. Direct dApp interaction. No browser switching. No extensions.',
    tags: ['WebOn-Compatible', '70+ Active', 'Open Standard'],
  },
  {
    num: '06',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    ),
    title: 'Decentralized Messenger',
    desc: 'Blockchain-based communication with value transfer built in. Send crypto by name — no wallet addresses, no friction.',
    detail: 'Text messaging · Name-to-name transfers · Encrypted · Voice & video expanding soon',
    tags: ['Encrypted', 'Name-to-Name', 'Rolling Out'],
  },
];

export default function Features() {
  const [ref, inView] = useInView();

  return (
    <section className="features" id="features" ref={ref}>
      <div className="features__aurora" aria-hidden="true">
        <div className="blob blob--indigo" />
        <div className="blob blob--violet" />
        <div className="blob blob--gold" />
      </div>

      <div className="container">
        <div className={`features__header reveal ${inView ? 'in-view' : ''}`}>
          <div className="section-label">Engineered for Perfection</div>
          <h2 className="section-title section-title--lg" style={{ maxWidth: '600px' }}>
            Every pixel. Every line of code.{' '}
            <span className="gradient-text">Obsessed over.</span>
          </h2>
        </div>

        <div className={`features__glass-wrap stagger ${inView ? 'in-view' : ''}`}>
          {FEATURES.map((f) => (
            <div className="feature-card" key={f.num}>
              <div className="feature-card__number">{f.num}</div>
              <div className="feature-card__icon">{f.icon}</div>
              <h3 className="feature-card__title">{f.title}</h3>
              <p className="feature-card__desc">{f.desc}</p>
              <p className="feature-card__detail">{f.detail}</p>
              <div className="feature-card__tags">
                {f.tags.map((t) => (
                  <span className="tag" key={t}>{t}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
